import React, { useState } from 'react';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import * as indexConteneurInfo from '../../../../ressources/glossaires/glossaire_conteneur_info';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';
import ConteneurInformation from '../../../ConteneurInformation/ConteneurInformation';
import Bouton from '../../../UI/Bouton/Bouton';
import S from './Alarmes.module.scss';
import ProfilAlarmeClient from './ProfilVue/ProfilAlarmeClient';
import TableauAlarmesClient from './TableauAlarmesClient/TableauAlarmesClient';

const Alarmes = ({ siLaListeAUneValeur }) => {
  const [parametresSelectione, setParametresSelectione] = useState({});
  const [montrerInfo, setMontrerInfo] = useState(false);
  const [indexConteneurInfoState, setIndexConteneurInfo] = useState(null);
  const [montrerInfoFull, setMontrerInfoFull] = useState(false);

  const ligneSelectione = (info) => {
    setParametresSelectione(info);
    setIndexConteneurInfo(indexConteneurInfo.profil);
    setMontrerInfo(true);
  };

  const commutateurInfoCreer = () => {
    if (montrerInfo) {
      setMontrerInfo(false);
      setMontrerInfoFull(false);
    } else {
      setMontrerInfo(true);
    }
  };

  const commutateurInfoFull = () => {
    setMontrerInfoFull(!montrerInfoFull);
  };

  const creerVue = () => {
    setMontrerInfo(true);
    setIndexConteneurInfo(indexConteneurInfo.ajouterForm);
  };

  let styleConteneurCentralGauche = [S.ConteneurCentralGauche];
  let styleConteneurCentralDroite = [S.ConteneurCentralDroite];
  let commutateurClasses = [S.CommutateurInfo];

  if (montrerInfo && montrerInfoFull) {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFull);
    styleConteneurCentralGauche.push(S.ConteneurCentraGaucheVoid);
  } else if (montrerInfo && !montrerInfoFull) {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteOuvert);
  } else {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFermer);
    styleConteneurCentralGauche.push(S.ConteneurCentraGaucheFermer);
  }

  return (
    <>
      <div className={[S.ConteneurVue].join(' ')}>
        <div className={styleConteneurCentralGauche.join(' ')}>
          <TableauAlarmesClient
            siLaListeAUneValeur={siLaListeAUneValeur}
            vueSelectione={ligneSelectione}
            creer={creerVue}
          />
        </div>
        <div className={styleConteneurCentralDroite.join(' ')}>
          <Bouton
            ajoutClass={[commutateurClasses, S.expandTO].join(' ')}
            cliquer={commutateurInfoCreer}
            rond={true}
            type={type_btn.danger}
          >
            <BiArrowFromLeft size={15} />
          </Bouton>
          <Bouton
            ajoutClass={S.expand}
            cliquer={commutateurInfoFull}
            rond={true}
            type={type_btn.danger}
          >
            <BiArrowFromRight size={15} />
          </Bouton>
          <ConteneurInformation
            selectionInfo={indexConteneurInfoState}
            profil={<ProfilAlarmeClient infoVue={parametresSelectione} />}
          />
        </div>
      </div>
    </>
  );
};

export default Alarmes;
